import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WaitForElementService {

  constructor() { }

  waitForEl(selector: string): Observable<HTMLElement> {
    return new Observable((observer: Observer<HTMLElement>) => {
      const elemento = document.querySelector(selector) as HTMLElement;

      if (elemento) {
        observer.next(elemento);
        observer.complete();
        return;
      }

      const mutationObserver = new MutationObserver(() => {
        const element = document.querySelector(selector) as HTMLElement;

        if (element) {
          observer.next(element);
          observer.complete();
          mutationObserver.disconnect();
        }
      });

      mutationObserver.observe(document.body, { childList: true, subtree: true });
    });
  }
}
